import { render, staticRenderFns } from "./ScenkonstSite.vue?vue&type=template&id=38b05100&scoped=true&"
import script from "./ScenkonstSite.vue?vue&type=script&lang=ts&"
export * from "./ScenkonstSite.vue?vue&type=script&lang=ts&"
import style0 from "./ScenkonstSite.vue?vue&type=style&index=0&id=38b05100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b05100",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogotypeFull: require('/tmp/build_453bf6d7/src/components/misc/LogotypeFull.vue').default})
